// 菜单改名时需同步后端 SensitiveReportAccessService 的授权路径映射。
export const SCORE_RESULT_360_PATH = '/oa/r-6d5e5b918e1c'
export const GUANYUAN_REPORT_PATH = '/portal/guanyuanpage'
export const SCORE_RESULT_PATH = '/oa/r-27b056df8d95'
